import React from 'react';
import Page from 'App/components/Page';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import ContentLibrary from './ContentLibrary';

function ContentLibraryPage() {
    return (
        <Page title="Content Library" showPageTitle permissionType={PERMISSION_TYPES.CONTENT_PUBLISHER}>
            <ContentLibrary />
        </Page>
    );
}

export default ContentLibraryPage;
